import LotteryNumlotDetailContainer from "../../components/lottery/containers/LotteryNumlotDetailContainer";
import LotteryNumlotDetailTemplate from "../../components/lottery/templates/LotteryNumlotDetailTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Bingo5() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="bg5" />
      <section className="min-h-screen">
        <LotteryNumlotDetailContainer lotteryKey="bg5" Template={LotteryNumlotDetailTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="bg5" />
    </>
  );
}
export default Bingo5;
